import cn from 'classnames';
import StatusIndicatorType from './StatusIndicatorType';
import styles from './statusIndicator.module.scss';

export interface IProps {
  /**
   * Specifies the status of the indicator (e.g., 'success', 'error', 'warning', 'loading').
   */
  status?: string,
  /**
   * Label text associated with the status indicator.
   */
  label?: string,
  /**
   * Title text for additional context or tooltip.
   */
  title?: string,
  /**
   * Additional CSS class for styling the status indicator container.
   */
  className?: string,
  /**
   * Additional CSS class for styling the label associated with the status indicator.
   */
  labelCls?: string,
}

const mapStatusToClassName = {
  [StatusIndicatorType.pending]: styles.isPending,
  [StatusIndicatorType.published]: styles.isPublished,
  [StatusIndicatorType.live]: styles.isLive,
  [StatusIndicatorType.scheduled]: styles.isScheduled,
  [StatusIndicatorType.unpublished]: styles.isUnpublished,
  [StatusIndicatorType.expired]: styles.isExpired,
};

function StatusIndicator({ status = StatusIndicatorType.pending as keyof typeof StatusIndicatorType, label = '', title = '', className, labelCls }: IProps) {
  const statusIndicatorCls = cn(styles.statusIndicator, className, {
    [mapStatusToClassName[status]]: true,
  });

  return (
    <>
      <span
        className={ statusIndicatorCls }
        title={ title }
      />
      { label && (
        <span className={ cn(styles.statusIndicatorLabel, labelCls) }>{ label }</span>
      ) }
    </>
  );
}

export default StatusIndicator;
